import type { NavigateFunction, NavigateOptions } from "react-router-dom";

type NavigationClickEvent = {
    button?: number;
    ctrlKey?: boolean;
    metaKey?: boolean;
    shiftKey?: boolean;
    altKey?: boolean;
    preventDefault?: () => void;
};

const isModifiedNavigationClick = (event?: NavigationClickEvent | null) => {
    if (!event) {
        return false;
    }

    return Boolean(
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.button === 1
    );
};

export const toInternalBrowserUrl = (target: string) => {
    if (typeof window === "undefined") {
        return target;
    }

    if (!target) {
        return window.location.origin + "/home";
    }

    if (target.startsWith("/")) {
        return new URL(target, window.location.origin).toString();
    }

    if (target.startsWith("workspace/")) {
        return new URL(`/home/${target}`, window.location.origin).toString();
    }

    return new URL(target, window.location.href).toString();
};

export const openInternalTargetInNewTab = (target: string) => {
    if (typeof window === "undefined") {
        return;
    }

    window.open(toInternalBrowserUrl(target), "_blank", "noopener,noreferrer");
};

export const navigateFromClick = (
    event: NavigationClickEvent | null | undefined,
    navigate: NavigateFunction,
    target: string,
    options?: NavigateOptions
) => {
    if (isModifiedNavigationClick(event)) {
        event?.preventDefault?.();
        openInternalTargetInNewTab(target);
        return;
    }

    navigate(target, options);
};
